import { useEffect, useState } from "react";
import { ModalBase } from "../ModalBase";
import BasicCardDocumentos from "../../../pages/OtrosDocumentos/Components/BasicCardDocumentos";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleRestartStateFormaPago } from "../../../actions/forma-pago.actions";
import { State } from "../../../reducers";
import { generalSetValidReturn } from "../../../actions/general.actions";

export default function ModalSalir ({title, warning, onConfirmExit, includeText, excludeValidate} : {title?: string, warning?: string, onConfirmExit?: any, includeText?: string, excludeValidate?: boolean}){
    const {validReturnHome} = useSelector((state: State) => state.general);
    const [showModal, setShowModal] = useState(false)
    const [newURL, setNewURL] = useState('')
    const history = useHistory()
    const dispatch = useDispatch()

    const handleExit = () => {
        onConfirmExit && onConfirmExit()
        dispatch(handleRestartStateFormaPago())
        history.push(newURL+'@ALLOW')
    }

    const handleCancel = () => {
        setShowModal(false)
        setNewURL('')
    }

    useEffect(() => {
        if (excludeValidate) { 
            return () => {
                setShowModal(false);
            };
        }

        if (validReturnHome) {
            history.push(validReturnHome);
            dispatch(generalSetValidReturn(''));
            return () => {
                setShowModal(false);
            };
        }

        const unblock = history.block((tx) => {
            let allow = tx.pathname.split('@')[1]
            let equal = includeText ? tx.pathname.includes(includeText) : false;
            tx.pathname = tx.pathname.split('@')[0]
            
            if(!allow && tx.pathname !== '/' && !equal){
                setShowModal(true)
                setNewURL(tx.pathname)
                    return false;
            }
            });
            
            return () => {
                unblock();
            };
    }, [history, excludeValidate, validReturnHome])

    return (
        <>
        {showModal &&
        <ModalBase>
            <BasicCardDocumentos title={title ?? "Salir"}>
            <p style={{textAlign: 'center'}}>{warning ?? 'Estas a punto de salir, todos los datos ingresados se perderán, ¿Deseas continuar?'}</p>
            <div style={{display: 'flex', gap: '20px'}}>
                <button onClick={handleCancel} className="button transparent">Cancelar</button>
                <button onClick={handleExit} className="button">Salir</button>
            </div>
            </BasicCardDocumentos>
        </ModalBase>       
        }
        </>
    )
}